<div appUiPanelCard class="composer-box" [class.composer-box--note]="noteMode()">
  @if (replyBlocked()) {
    <p class="composer-window-banner">
      <ng-icon name="heroLockClosed" size="14" aria-hidden="true" />
      @if (channelInactive()) {
        <span>Número desativado em <strong>Integrações › Canais</strong>. Reative para enviar ou receber mensagens. Notas internas continuam liberadas.</span>
      } @else if (canReopenWithTemplate()) {
        <span>
          A janela de 24h para mensagens livres está fechada. Envie um template aprovado para falar com o contato — notas internas continuam liberadas.
          <button appButton variant="ghost" size="sm" type="button" class="composer-window-banner__cta" (click)="openTemplatePicker()">Enviar template</button>
        </span>
      } @else {
        <span>A janela de 24h para mensagens livres está fechada. Aguarde uma nova mensagem do contato para responder. Notas internas continuam liberadas.</span>
      }
    </p>
  }
  @if (store.replyTarget(); as target) {
    <div class="composer-reply-preview">
      <div class="composer-reply-preview__body">
        <span class="composer-reply-preview__sender">{{ quotedSenderLabel(target.sender) }}</span>
        <span class="composer-reply-preview__text">{{ target.body.trim() || 'Anexo' }}</span>
      </div>
      <button
        appUiIconButton
        variant="ghost"
        size="xs"
        type="button"
        aria-label="Cancelar resposta"
        (click)="store.clearReplyTarget()"
      >
        <ng-icon name="heroXMark" size="14" aria-hidden="true" />
      </button>
    </div>
  }
  <textarea
    appTextarea
    surface="transparent"
    rows="1"
    [placeholder]="noteMode() ? 'Nota interna' : 'Digite aqui...'"
    [value]="text()"
    [disabled]="replyBlocked()"
    (input)="setText($any($event.target).value)"
    (keydown)="onKeydown($event)"
  ></textarea>

  @if (pending().length > 0) {
    <ul class="composer-previews">
      @for (item of pending(); track item.localId) {
        @if (item.source === 'voice' && item.previewUrl) {
          <li class="composer-voice-preview" [class.composer-voice-preview--error]="item.status === 'error'">
            <app-audio-player [src]="item.previewUrl" [compact]="true" />
            @if (item.status === 'uploading') {
              <span class="composer-chip__status">Enviando…</span>
            } @else if (item.status === 'error') {
              <span class="composer-chip__status composer-chip__status--error">{{ item.errorMessage }}</span>
            }
            <button
              appUiIconButton
              variant="danger"
              size="xs"
              type="button"
              [attr.aria-label]="'Descartar gravação'"
              (click)="removePendingFile($index)"
            >
              <ng-icon name="heroXMark" size="14" aria-hidden="true" />
            </button>
          </li>
        } @else {
          <li appBadge [tone]="item.status === 'error' ? 'danger' : 'neutral'" size="sm" class="composer-chip">
            <ng-icon [name]="iconFor(item.kind)" size="16" aria-hidden="true" />
            <span class="composer-chip__name" [title]="item.name">{{ item.name }}</span>
            @if (item.status === 'uploading') {
              <span class="composer-chip__size">Enviando…</span>
            } @else if (item.status === 'error') {
              <span class="composer-chip__size" [title]="item.errorMessage">{{ item.errorMessage }}</span>
            } @else {
              <span class="composer-chip__size">{{ item.size }}</span>
            }
            <button
              appUiIconButton
              variant="danger"
              size="xs"
              type="button"
              [attr.aria-label]="'Remover ' + item.name"
              (click)="removePendingFile($index)"
            >
              <ng-icon name="heroXMark" size="14" aria-hidden="true" />
            </button>
          </li>
        }
      }
    </ul>
  }

  <div class="composer-toolbar">
    <div class="composer-tools">
      <button
        *appIfPermission="'conversations:base:send_message'"
        appUiIconButton
        variant="ghost"
        size="md"
        type="button"
        title="Anexar arquivo"
        aria-label="Anexar arquivo"
        [disabled]="isUploading() || noteMode() || replyBlocked()"
        (click)="fileInput.click()"
      >
        <ng-icon name="heroPaperClip" size="18" aria-hidden="true" />
      </button>
      <input #fileInput appUiFileInput type="file" multiple (change)="onFilesSelected(fileInput)" />

      @if (canRecord) {
        <button
          *appIfPermission="'conversations:base:send_message'"
          appUiIconButton
          variant="ghost"
          size="md"
          type="button"
          [class.composer-tool--recording]="recorder.isRecording()"
          [title]="recorder.isRecording() ? 'Parar gravação' : 'Gravar áudio'"
          [attr.aria-label]="recorder.isRecording() ? 'Parar gravação' : 'Gravar áudio'"
          [disabled]="replyBlocked()"
          (click)="toggleRecording()"
        >
          <ng-icon [name]="recorder.isRecording() ? 'heroStop' : 'heroMicrophone'" size="18" aria-hidden="true" />
        </button>
      }

      <button
        *appIfPermission="'conversations:base:notes:write'"
        appUiIconButton
        variant="ghost"
        size="md"
        type="button"
        [class.composer-tool--note]="noteMode()"
        [attr.aria-pressed]="noteMode()"
        [title]="noteMode() ? 'Modo nota interna ativo' : 'Escrever nota interna'"
        aria-label="Alternar nota interna"
        (click)="toggleNoteMode()"
      >
        <ng-icon name="heroPencilSquare" size="18" aria-hidden="true" />
      </button>

      @if (hasTemplates()) {
        <button
          *appIfPermission="'conversations:base:send_message'"
          appUiIconButton
          variant="ghost"
          size="md"
          type="button"
          title="Enviar template aprovado"
          aria-label="Enviar template aprovado"
          [disabled]="noteMode()"
          (click)="openTemplatePicker()"
        >
          <ng-icon name="heroDocumentText" size="18" aria-hidden="true" />
        </button>
      }

      <button appUiIconButton variant="ghost" size="md" type="button" title="Sugestão com IA (em breve)" aria-label="Sugestão com IA" disabled>
        <ng-icon name="heroSparkles" size="18" aria-hidden="true" />
      </button>
    </div>

    <button
      appUiIconButton
      *appIfPermission="'conversations:base:send_message'"
      [variant]="noteMode() ? 'danger' : 'accent'"
      size="md"
      shape="pill"
      type="button"
      class="composer-send"
      [class.composer-send--note]="noteMode()"
      [disabled]="store.isSending() || isUploading() || !hasContent() || replyBlocked()"
      [title]="noteMode() ? 'Salvar nota' : 'Enviar'"
      aria-label="Enviar"
      (click)="send()"
    >
      <ng-icon name="heroPaperAirplane" size="18" aria-hidden="true" />
    </button>
  </div>
</div>

@if (templatePickerOpen()) {
  <app-template-picker-dialog
    [templates]="store.templatesForSelectedChannel()"
    (submitted)="onTemplateSubmit($event)"
    (dismissed)="closeTemplatePicker()"
  />
}
